

import React, { useEffect, useState } from 'react';

import '../styles/phcolours.css';


/*-----------------------------------------------------------------------------*/


const Crosshairs = ({ map, showCrosshairs }) => {

  const [mapContainer, setMapContainer] = useState(null);

  useEffect(() => {
    if (map && typeof map.getDiv === 'function') {
      setMapContainer(map.getDiv());
    }
  }, [map]);

  if (!mapContainer || !showCrosshairs) return null;

  const crosshairLength = '200';

  const verticalLineStyle = {
    position: 'absolute',
    top: '50%',
    marginTop: `-${crosshairLength / 2}px`,
    left: '50%',
    width: '1.5px',
    height: `${crosshairLength}px`,
    backgroundColor: 'var(--phblueaccent)',
    zIndex: 1001,
    pointerEvents: 'none'
  };

  const horizontalLineStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginLeft: `-${crosshairLength / 2}px`,
    width: `${crosshairLength}px`,
    height: '1.5px',
    backgroundColor: 'var(--phblueaccent)',
    zIndex: 1001,
    pointerEvents: 'none'
  };

  return (
    <>
      <div style={verticalLineStyle} />
      <div style={horizontalLineStyle} />
    </>
  );
};

export default Crosshairs;


